import React from 'react';
import { cn } from './cn';

/** shadcn/ui Input. Hatalı alanda `aria-invalid` verilince kırmızı çerçeve alır. */
export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full min-w-0 rounded-md border border-input bg-field px-3 py-1 text-sm text-foreground shadow-xs outline-none',
        'transition-[color,box-shadow] placeholder:text-muted-foreground selection:bg-brand/30',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className
      )}
      {...props}
    />
  )
);
Input.displayName = 'Input';

/** shadcn/ui Textarea — Input ile aynı çerçeve ve odak görünümü. */
export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-28 w-full resize-none rounded-md border border-input bg-field px-3 py-2 text-sm text-foreground shadow-xs outline-none',
        'transition-[color,box-shadow] placeholder:text-muted-foreground selection:bg-brand/30',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({ className, ...props }) => (
  <label className={cn('flex items-center gap-2 text-sm font-medium leading-none text-foreground', className)} {...props} />
);

export const Separator: React.FC<{ className?: string }> = ({ className }) => (
  <div role="separator" className={cn('h-px w-full shrink-0 bg-border', className)} />
);
